import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import AppTheme from '@libs/mui/AppTheme';
import { useUserDataQuery } from '@shared/queries';
import { useRef } from 'react';

export const useLayoutBottomBar = () => {
  const { data: userData } = useUserDataQuery();
  const colorScheme = userData?.colorScheme ?? AppTheme.palette.primary.main;
  const { t } = useIntlTranslations();

  const clientDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const visitDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const stockItemDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const serviceDialogRef = useRef<ImperativeFormDialogRefType | null>(null);

  return {
    t,
    colorScheme,
    clientDialogRef,
    visitDialogRef,
    stockItemDialogRef,
    serviceDialogRef,
  };
};
